import React from 'react';
import logoSmallWebp from '../../assets/logo-small.webp';
import logoMediumWebp from '../../assets/logo-medium.webp';
import logoLargeWebp from '../../assets/logo-large.webp';
import logoSmallPng from '../../assets/logo-small.png';
import logoMediumPng from '../../assets/logo-medium.png';
import logoLargePng from '../../assets/logo-large.png';

interface LogoProps {
  className?: string;
  alt?: string;
}

export const Logo: React.FC<LogoProps> = ({ 
  className = "h-16 w-16 object-contain",
  alt = "Cognitive Bias Lab Logo" 
}) => {
  return (
    <picture>
      {/* WebP sources */}
      <source
        type="image/webp"
        srcSet={`
          ${logoSmallWebp} 64w,
          ${logoMediumWebp} 128w,
          ${logoLargeWebp} 256w
        `}
        sizes="(max-width: 768px) 64px, 128px"
      />
      {/* PNG fallback sources */}
      <source
        type="image/png"
        srcSet={`
          ${logoSmallPng} 64w,
          ${logoMediumPng} 128w,
          ${logoLargePng} 256w
        `}
        sizes="(max-width: 768px) 64px, 128px"
      />
      {/* Fallback image - using WebP with PNG as ultimate fallback */}
      <img
        src="/logo.webp"
        alt={alt}
        className={className}
        loading="eager"
        decoding="async"
        width={128}
        height={128}
        crossOrigin="anonymous"
        onError={(e) => {
          // If WebP fails to load, fall back to PNG
          const imgElement = e.currentTarget;
          imgElement.onerror = null; // Prevent infinite loop
          imgElement.src = '/logo.png';
        }}
      />
    </picture>
  );
}; 